import React from 'react';

export default function ToastContainer({ toasts }) {
  if (!toasts.length) return null;
  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div key={t.id} className="toast">
          <i className={`fas ${t.icon}`} style={{ color: 'var(--gold)' }} />
          {t.message}
        </div>
      ))}
    </div>
  );
}
